import React, { useEffect, useRef, useState } from "react";
import ImageLinks from "../../assets/Images/ImagesLink";
import _ from "lodash";
import api_requests from "../../resources/api_requests";
import { useLocation, useNavigate } from "react-router-dom";
import {
  hide_loader,
  set_reciver_details,
  show_loader,
} from "../../actions/app";
import { useDispatch } from "react-redux";
import { ArrowRightFilledCircle } from "../../assets/whiteLabelIcon";
import { useTranslation } from "react-i18next";

const SearchFrequentCustomer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [number, set_number] = useState("");
  const [search_items, set_search_items] = useState([]);
  const [selected_item, set_selected_item] = useState(null);
  const [is_error, set_is_error] = useState(false);
  const { t } = useTranslation();

  const handle_back_press = () => {
    navigate(-1);
  };
  const handle_change = (e) => {
    set_is_error(false);
    set_number(e.target.value);
  };
  const handle_search = async (e) => {
    e.preventDefault();
    if (_.isEmpty(number) || number.length != 10) return;
    try {
      dispatch(show_loader());
      const res = await api_requests.get_orders_list({
        customer_mobile: number,
        limit: 3,
        group: "completed",
      });
      if (_.isEmpty(res.data.items)) set_is_error(true);
      set_search_items(res.data.items);
      dispatch(hide_loader());
    } catch (err) {
      dispatch(hide_loader());
    }
    return;
  };

  const create_frequent_customer = () => {
    const payload = {
      name: selected_item?.customer_detail?.name,
      mobile: selected_item?.customer_detail?.mobile,
      id: selected_item?.customer_detail?.address?.id,
      coordinates: {
        latitude: selected_item?.customer_detail?.address?.latitude,
        longitude: selected_item?.customer_detail?.address?.longitude,
      },
      city: selected_item?.customer_detail?.address?.city,
      state: selected_item?.customer_detail?.address?.state,
      pincode: selected_item?.customer_detail?.address?.pincode,
      address_name: selected_item?.customer_detail?.address?.address_line_1,
      address_line1: selected_item?.customer_detail?.address?.address_line_2,
    };

    dispatch(set_reciver_details(payload));
    navigate("/cart");
  };

  return (
    <div className="min-h-screen px-6 py-5">
      <div className="flex items-center gap-2" onClick={handle_back_press}>
        <img src={ImageLinks.chevron_right} className="w-[18px] h-[19px]" />
        <p className="font-custom text-sm font-semibold text-dark_black">
          {t("frequent_deliveries")}
        </p>
      </div>

      <div
        className={`flex items-center border border-accents rounded-[30px]  px-4 py-2 bg-white mt-6`}
      >
        <input
          id="pac-input"
          type="number"
          placeholder={t("search_customer_number")}
          className={`w-full text-gray-700 placeholder-gray-500 bg-transparent text-sm focus:outline-none`}
          onChange={handle_change}
          value={number}
        />
        <div
          style={{
            opacity: _.isEmpty(number) || number.length != 10 ? 0.3 : 1,
          }}
          onClick={handle_search}
        >
          <ArrowRightFilledCircle />
        </div>
      </div>
      {search_items.length > 0 && (
        <div className="flex gap-1 mt-2 items-center">
          <img src={ImageLinks.location_1} className="w-[16px] h-[16px]" />
          <p className="font-custom text-xs font-semibold text-dark_black">
            {t("search_delivery_location")}
          </p>
        </div>
      )}
      {is_error && (
        <div className="mt-6 text-center px-7">
          <p className="font-custom font-semibold text-xs text-error">
            {t("no_customer_found")}.{" "}
            {t("kindly_add_contact_number_of_your_frequent_customer")}.
          </p>
        </div>
      )}
      <div>
        {_.map(search_items, (addr_item, addr_index) => (
          <div
            key={`search_item_${addr_index}`}
            className={`mt-4 rounded-lg py-3 px-4 border-[1px] ${
              selected_item?.id === addr_item?.id
                ? "border-secondary"
                : "border-accents"
            }`}
            onClick={() => set_selected_item(addr_item)}
          >
            <p className="font-custom font-bold text-xs">
              {addr_item?.customer_detail?.address?.address_line_1}
            </p>
            <p className="font-custom font-semibold text-[10px] text-dark_gray mt-1">
              {addr_item?.customer_detail?.address?.address_line_2}
            </p>
            <p className="font-custom font-medium text-[10px] text-dark_gray">
              {addr_item?.customer_detail?.name}
              &nbsp;|&nbsp;
              {addr_item?.customer_detail?.mobile}
            </p>
          </div>
        ))}
      </div>

      {search_items.length > 0 && (
        <button
          onClick={create_frequent_customer}
          className="font-custom btn btn-block bg-primary text-white cursor-not-allowed rounded-[30px] mt-10"
          disabled={_.isEmpty(selected_item)}
        >
          {t("confirm")}
        </button>
      )}
    </div>
  );
};

export default SearchFrequentCustomer;
